function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null);

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, React.createElement("path", {
  className: "cls-1",
  d: "M99,475.3V420c-39-1.7-76.9-12.2-99-25l17.5-68.1c24.5,13.4,58.8,25.6,96.7,25.6,33.2,0,55.9-12.8,55.9-36.1,0-22.1-18.6-36.1-61.7-50.7C46.1,244.7,3.6,215.6,3.6,159.1c0-51.3,36.1-91.4,98.4-103.7V0h57.1V51.3c39,1.7,65.2,9.9,84.5,19.2l-16.9,65.8c-15.1-6.4-41.9-19.8-83.9-19.8-37.9,0-50.1,16.3-50.1,32.6,0,19.2,20.4,31.5,69.9,50.1,69.3,24.5,97.3,56.5,97.3,108.9,0,51.8-36.7,96.1-103.7,107.8v59.4Z"
})));

var SvgUsd = function SvgUsd(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 259.9 475.3",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgUsd, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/usd.6de6797d.svg";
export { ForwardRef as ReactComponent };